var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 193,
    viewBox: "0 0 203 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.281 188.818C202.281 191.088 157.155 192.93 101.5 192.93C45.8443 192.93 0.71875 191.088 0.71875 188.818C0.71875 186.547 45.8386 184.699 101.5 184.699C157.161 184.699 202.281 186.541 202.281 188.818Z",
    fill: "#1F85F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M202.281 188.818C202.281 191.088 157.155 192.93 101.5 192.93C45.8443 192.93 0.71875 191.088 0.71875 188.818C0.71875 186.547 45.8386 184.699 101.5 184.699C157.161 184.699 202.281 186.541 202.281 188.818Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.523 7.79407H31.984C28.2541 7.79407 25.2305 10.8177 25.2305 14.5476V98.0742C25.2305 101.804 28.2541 104.828 31.984 104.828H164.523C168.252 104.828 171.276 101.804 171.276 98.0742V14.5476C171.276 10.8177 168.252 7.79407 164.523 7.79407Z",
    fill: "#1F85F6",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M164.523 7.79407H31.984C28.2541 7.79407 25.2305 10.8177 25.2305 14.5476V98.0742C25.2305 101.804 28.2541 104.828 31.984 104.828H164.523C168.252 104.828 171.276 101.804 171.276 98.0742V14.5476C171.276 10.8177 168.252 7.79407 164.523 7.79407Z",
    fill: "#1F85F6",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8286 62.042H69.7422V71.6278H86.8286V62.042Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8286 73.3596H69.7422V82.9454H86.8286V73.3596Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.653 62.042H88.5664V71.6278H105.653V62.042Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.482 50.7186H107.396V60.3044H124.482V50.7186Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.482 39.3953H107.396V48.981H124.482V39.3953Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.482 18.4688H107.396V26.3343H124.482V18.4688Z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.653 18.4688H88.5664V26.3343H105.653V18.4688Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.653 73.3596H88.5664V82.9454H105.653V73.3596Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.653 28.0719H88.5664V37.6577H105.653V28.0719Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.653 39.3953H88.5664V48.981H105.653V39.3953Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M105.653 50.7186H88.5664V60.3044H105.653V50.7186Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M124.482 73.3596H107.396V82.9454H124.482V73.3596Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1749 28.0719H30.959V37.6577H49.1749V28.0719Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1749 50.7186H30.959V60.3044H49.1749V50.7186Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1749 62.042H30.959V71.6278H49.1749V62.042Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1749 39.3953H30.959V48.981H49.1749V39.3953Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M163.266 18.4688H145.05V26.3343H163.266V18.4688Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1749 73.3596H30.959V82.9454H49.1749V73.3596Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M143.306 28.0719H126.22V37.6577H143.306V28.0719Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M124.482 62.042H107.396V71.6278H124.482V62.042Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M143.306 62.042H126.22V71.6278H143.306V62.042Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.306 39.3953H126.22V48.981H143.306V39.3953Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M143.306 50.7186H126.22V60.3044H143.306V50.7186Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M143.306 73.3596H126.22V82.9454H143.306V73.3596Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M124.482 28.0719H107.396V37.6577H124.482V28.0719Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M163.266 73.3596H145.05V82.9454H163.266V73.3596Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M143.306 18.4688H126.22V26.3343H143.306V18.4688Z",
    fill: "#263238"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M163.266 62.042H145.05V71.6278H163.266V62.042Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M143.306 84.683H126.22V94.8132H143.306V84.683Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M163.266 50.7186H145.05V60.3044H163.266V50.7186Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M105.653 84.683H88.5664V94.8132H105.653V84.683Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M124.482 84.683H107.396V94.8132H124.482V84.683Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M163.266 39.3953H145.05V48.981H163.266V39.3953Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M163.266 84.683H145.05V94.8132H163.266V84.683Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1749 84.683H30.959V94.8132H49.1749V84.683Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M163.266 28.0719H145.05V37.6577H163.266V28.0719Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1749 18.4688H30.959V26.3343H49.1749V18.4688Z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9986 18.4688H50.9121V26.3343H67.9986V18.4688Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9986 62.042H50.9121V71.6278H67.9986V62.042Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8286 18.4688H69.7422V26.3343H86.8286V18.4688Z",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8286 39.3953H69.7422V48.981H86.8286V39.3953Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9986 73.3596H50.9121V82.9454H67.9986V73.3596Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8286 28.0719H69.7422V37.6577H86.8286V28.0719Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9986 28.0719H50.9121V37.6577H67.9986V28.0719Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8286 50.7186H69.7422V60.3044H86.8286V50.7186Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9986 50.7186H50.9121V60.3044H67.9986V50.7186Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9986 84.683H50.9121V94.8132H67.9986V84.683Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9986 39.3953H50.9121V48.981H67.9986V39.3953Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8286 84.683H69.7422V94.8132H86.8286V84.683Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9977 13.1807C40.3572 13.1807 41.4593 12.0786 41.4593 10.7191C41.4593 9.35954 40.3572 8.25745 38.9977 8.25745C37.6382 8.25745 36.5361 9.35954 36.5361 10.7191C36.5361 12.0786 37.6382 13.1807 38.9977 13.1807Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7942 10.719C49.7953 10.2305 49.6514 9.75269 49.3808 9.34604C49.1101 8.9394 48.7248 8.62224 48.2737 8.43478C47.8226 8.24731 47.326 8.19796 46.8468 8.29298C46.3677 8.388 45.9275 8.62311 45.5821 8.96853C45.2366 9.31395 45.0015 9.75413 44.9065 10.2333C44.8115 10.7125 44.8608 11.2091 45.0483 11.6602C45.2358 12.1112 45.5529 12.4965 45.9596 12.7672C46.3662 13.0379 46.8441 13.1818 47.3326 13.1806C47.9854 13.1806 48.6115 12.9213 49.0732 12.4597C49.5348 11.998 49.7942 11.3719 49.7942 10.719Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0446 12.3234C38.702 12.3234 38.3735 12.1873 38.1312 11.9451C37.889 11.7029 37.7529 11.3743 37.7529 11.0318V2.29741C37.7522 2.12731 37.785 1.95873 37.8496 1.80135C37.9142 1.64398 38.0092 1.50091 38.1292 1.38035C38.2492 1.2598 38.3919 1.16414 38.5489 1.09887C38.706 1.0336 38.8745 0.999998 39.0446 1C39.3887 1 39.7187 1.13669 39.962 1.38C40.2053 1.62332 40.342 1.95332 40.342 2.29741V11.0318C40.342 11.2019 40.3084 11.3703 40.2431 11.5274C40.1778 11.6845 40.0822 11.8271 39.9616 11.9471C39.8411 12.0672 39.698 12.1622 39.5406 12.2267C39.3832 12.2913 39.2147 12.3242 39.0446 12.3234Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4547 12.3234C47.1122 12.3234 46.7836 12.1873 46.5414 11.9451C46.2992 11.7029 46.1631 11.3743 46.1631 11.0318V2.29741C46.1623 2.12731 46.1952 1.95873 46.2598 1.80135C46.3243 1.64398 46.4193 1.50091 46.5393 1.38035C46.6594 1.2598 46.802 1.16414 46.9591 1.09887C47.1162 1.0336 47.2846 0.999998 47.4547 1C47.7988 1 48.1288 1.13669 48.3721 1.38C48.6154 1.62332 48.7521 1.95332 48.7521 2.29741V11.0318C48.7521 11.2019 48.7185 11.3703 48.6533 11.5274C48.588 11.6845 48.4923 11.8271 48.3718 11.9471C48.2512 12.0672 48.1082 12.1622 47.9508 12.2267C47.7934 12.2913 47.6248 12.3242 47.4547 12.3234Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M152.614 10.719C152.616 10.2305 152.472 9.75269 152.201 9.34604C151.93 8.9394 151.545 8.62224 151.094 8.43478C150.643 8.24731 150.146 8.19796 149.667 8.29298C149.188 8.388 148.748 8.62311 148.402 8.96853C148.057 9.31395 147.822 9.75413 147.727 10.2333C147.632 10.7125 147.681 11.2091 147.869 11.6602C148.056 12.1112 148.373 12.4965 148.78 12.7672C149.187 13.0379 149.664 13.1818 150.153 13.1806C150.806 13.1806 151.432 12.9213 151.893 12.4597C152.355 11.998 152.614 11.3719 152.614 10.719Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M158.481 13.1807C159.841 13.1807 160.943 12.0786 160.943 10.7191C160.943 9.35954 159.841 8.25745 158.481 8.25745C157.122 8.25745 156.02 9.35954 156.02 10.7191C156.02 12.0786 157.122 13.1807 158.481 13.1807Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M150.193 12.3234C149.85 12.3234 149.522 12.1873 149.28 11.9451C149.037 11.7029 148.901 11.3743 148.901 11.0318V2.29741C148.901 2.12731 148.933 1.95873 148.998 1.80135C149.063 1.64398 149.158 1.50091 149.278 1.38035C149.398 1.2598 149.54 1.16414 149.697 1.09887C149.854 1.0336 150.023 0.999998 150.193 1C150.537 1 150.867 1.13669 151.11 1.38C151.354 1.62332 151.49 1.95332 151.49 2.29741V11.0318C151.49 11.2019 151.457 11.3703 151.392 11.5274C151.326 11.6845 151.231 11.8271 151.11 11.9471C150.989 12.0672 150.846 12.1622 150.689 12.2267C150.532 12.2913 150.363 12.3242 150.193 12.3234Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M158.609 12.3234C158.437 12.3265 158.267 12.2953 158.107 12.2318C157.948 12.1683 157.803 12.0736 157.68 11.9534C157.558 11.8331 157.461 11.6897 157.394 11.5315C157.328 11.3732 157.294 11.2034 157.294 11.0318V2.29741C157.294 1.95332 157.431 1.62332 157.674 1.38C157.917 1.13669 158.247 1 158.591 1C158.761 0.999998 158.93 1.0336 159.087 1.09887C159.244 1.16414 159.387 1.2598 159.507 1.38035C159.627 1.50091 159.722 1.64398 159.786 1.80135C159.851 1.95873 159.884 2.12731 159.883 2.29741V11.0318C159.883 11.3713 159.749 11.6973 159.511 11.939C159.272 12.1807 158.948 12.3188 158.609 12.3234Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5778 13.1807C95.9373 13.1807 97.0394 12.0786 97.0394 10.7191C97.0394 9.35954 95.9373 8.25745 94.5778 8.25745C93.2183 8.25745 92.1162 9.35954 92.1162 10.7191C92.1162 12.0786 93.2183 13.1807 94.5778 13.1807Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M102.907 13.1807C104.266 13.1807 105.369 12.0786 105.369 10.7191C105.369 9.35954 104.266 8.25745 102.907 8.25745C101.547 8.25745 100.445 9.35954 100.445 10.7191C100.445 12.0786 101.547 13.1807 102.907 13.1807Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6188 12.3234C94.2762 12.3234 93.9477 12.1873 93.7055 11.9451C93.4632 11.7029 93.3272 11.3743 93.3272 11.0318V2.29741C93.3264 2.12731 93.3592 1.95873 93.4238 1.80135C93.4884 1.64398 93.5834 1.50091 93.7034 1.38035C93.8234 1.2598 93.9661 1.16414 94.1232 1.09887C94.2802 1.0336 94.4487 0.999998 94.6188 1C94.9629 1 95.2929 1.13669 95.5362 1.38C95.7795 1.62332 95.9162 1.95332 95.9162 2.29741V11.0318C95.9162 11.2019 95.8826 11.3703 95.8173 11.5274C95.7521 11.6845 95.6564 11.8271 95.5358 11.9471C95.4153 12.0672 95.2722 12.1622 95.1148 12.2267C94.9575 12.2913 94.7889 12.3242 94.6188 12.3234Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M103.029 12.3234C102.686 12.3234 102.358 12.1873 102.116 11.9451C101.873 11.7029 101.737 11.3743 101.737 11.0318V2.29741C101.737 2.12731 101.769 1.95873 101.834 1.80135C101.899 1.64398 101.994 1.50091 102.114 1.38035C102.234 1.2598 102.376 1.16414 102.533 1.09887C102.69 1.0336 102.859 0.999998 103.029 1C103.199 1 103.368 1.03356 103.525 1.09876C103.683 1.16396 103.826 1.25953 103.946 1.38C104.067 1.50048 104.162 1.6435 104.228 1.80091C104.293 1.95832 104.326 2.12703 104.326 2.29741V11.0318C104.326 11.2019 104.293 11.3703 104.227 11.5274C104.162 11.6845 104.067 11.8271 103.946 11.9471C103.825 12.0672 103.682 12.1622 103.525 12.2267C103.368 12.2913 103.199 12.3242 103.029 12.3234Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7865 40.2294L34.168 47.8285",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8203 40.2294L42.7861 47.3188",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M138.175 29.4214L129.557 37.0147",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M132.209 29.4214L138.175 36.5108",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6966 29.4214L73.0723 37.0147",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7256 29.4214L81.6972 36.5108",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M157.891 29.2072L149.267 36.8063",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M151.919 29.2072L157.891 36.2966",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M125.895 119.099C125.895 119.099 124.105 129.142 123.833 134.923C123.561 140.703 124.934 144.827 125.484 150.608C126.034 156.388 129.608 178.537 129.608 180.327C129.708 181.999 129.222 183.653 128.235 185.006C127.135 186.518 123.555 187.902 123.833 188.441C124.111 188.98 125.756 189.82 128.646 188.858C131.537 187.897 131.676 186.929 132.776 186.929C133.877 186.929 136.217 186.24 135.799 184.613C135.382 182.985 133.344 179.527 133.483 173.469C133.755 159.435 133.066 135.241 133.066 135.241L137.468 121.758L125.895 119.099Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M128.386 184.781L128.236 185.006C127.135 186.518 123.556 187.902 123.834 188.441C124.112 188.98 125.757 189.82 128.647 188.858C131.537 187.897 131.676 186.929 132.777 186.929C133.877 186.929 136.217 186.24 135.8 184.613C135.673 184.091 135.377 183.39 135.041 182.487C133.72 183.494 132.317 184.389 130.848 185.163C130.193 185.406 129.22 185.134 128.386 184.781Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M138.1 59.7889C138.1 59.7889 137.451 57.5763 137.005 55.6071C136.559 53.6378 139.901 52.7864 143.567 52.4215C147.234 52.0566 152.418 54.7904 153.947 59.1344C155.476 63.4784 154.19 79.557 154.346 83.067C154.503 86.577 154.85 96.3018 151.288 96.9099C147.726 97.5181 143.979 97.7556 140.862 91.6508C137.746 85.546 141.164 69.4905 141.534 66.2644C141.905 63.0382 138.285 60.258 138.285 60.258L138.1 59.7889Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M145.93 55.2247C145.93 55.2247 145.687 58.9085 148.143 60.8719C150.599 62.8354 153.784 67.498 153.784 71.1817",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M150.599 65.2913C150.599 65.2913 152.336 71.6625 150.842 77.0722",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M131.7 120.825C131.7 120.825 128.804 133.915 131.474 145.227C132.203 148.32 143.457 176.064 144.343 180.5C145.23 184.937 145.23 188.933 147.008 190.486C148.786 192.038 149.904 191.372 149 186.269C148.394 183.42 147.42 180.661 146.104 178.062C146.104 178.062 142.774 156.765 142.328 152.108C141.882 147.451 139.223 141.902 139.223 141.902L143.44 123.71L131.7 120.825Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M148.426 183.865C148.212 185.024 147.748 186.026 146.781 185.835C146.328 185.748 145.911 185.53 145.581 185.208C145.252 184.885 145.024 184.473 144.928 184.022C145.362 186.953 145.715 189.368 147.007 190.492C148.779 192.044 149.903 191.378 149 186.275C148.854 185.462 148.663 184.657 148.426 183.865Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M144.789 182.707H144.737C144.737 182.811 144.766 182.916 144.784 183.014C144.78 182.912 144.782 182.809 144.789 182.707Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M135.713 75.9543C134.325 76.2872 133.113 77.131 132.319 78.3175C131.16 80.2346 120.37 88.3492 119.339 89.2296C118.308 90.11 118.453 94.5409 121.076 94.5409C123.7 94.5409 132.585 87.7585 132.585 87.7585C132.585 87.7585 135.238 84.5091 136.124 81.561C137.01 78.6129 137.63 76.2497 135.713 75.9543Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M138.661 68.4364C137.63 68.4364 136.611 70.8574 136.611 70.8574L135.638 71.0022C136.512 69.9654 137.63 68.4364 137.63 68.4364C138.51 66.9594 138.209 64.7468 137.63 64.8974C137.051 65.048 133.205 66.5192 132.614 67.2548C132.023 67.9904 130.251 73.8924 129.666 74.4832C129.081 75.074 119.339 87.4631 118.308 90.1217C117.277 92.7802 120.074 96.0237 122.438 94.402C124.801 92.7802 126.863 87.7585 127.755 84.2428C128.647 80.727 132.33 74.0604 132.33 74.0604C132.33 74.0604 133.188 73.3654 134.068 72.5892C135.03 72.3469 135.977 72.051 136.906 71.7031C137.485 71.4077 139.119 69.3399 139.119 69.3399C139.119 69.3399 139.692 68.4364 138.661 68.4364Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M136.183 63.6638L133.194 68.4017C133.034 68.6549 132.973 68.9577 133.021 69.2532C133.069 69.5486 133.223 69.8163 133.455 70.006L134.816 71.1239C134.948 71.2319 135.101 71.3111 135.266 71.3565C135.431 71.4018 135.603 71.4123 135.772 71.3872C135.941 71.3621 136.103 71.3021 136.248 71.2108C136.392 71.1196 136.516 70.9993 136.611 70.8575L139.779 66.1601C139.955 65.8978 140.024 65.578 139.971 65.2666C139.918 64.9552 139.748 64.6759 139.496 64.4863L137.955 63.3279C137.819 63.227 137.663 63.1554 137.498 63.1175C137.333 63.0797 137.162 63.0765 136.995 63.108C136.829 63.1396 136.671 63.2052 136.531 63.3009C136.391 63.3965 136.272 63.5201 136.183 63.6638Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M146.417 65.8184C146.417 65.8184 145.554 71.3497 145.31 73.4638C145.067 75.5779 145.131 76.0355 146.909 76.2382C148.687 76.4409 151.624 77.3445 152.776 80.0667C153.929 82.789 147.233 91.031 145.247 92.8092C143.26 94.5873 142.374 96.9852 142.814 98.8618C143.254 100.738 148.45 106.808 148.224 112.965C147.998 119.122 140.555 137.072 140.555 137.072C140.555 137.072 130.633 133.052 123.469 134.396C123.469 134.396 126.851 110.614 128.861 104.347C130.871 98.0799 132.916 94.6858 132.753 93.342C132.591 91.9983 130.089 88.0771 130.697 84.764C131.305 81.451 133.443 78.5492 134.439 76.7479C135.435 74.9466 137.572 74.9697 138.348 75.0566C139.125 75.1435 140.225 75.3868 140.775 74.5469C141.326 73.7071 141.818 69.3747 141.818 69.3747L146.417 65.8184Z",
    fill: "#1F85F6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M134.891 89.832L139.304 93.0234",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M138.974 103.629C138.974 103.629 134.549 112.073 133.547 118.109",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M133.749 112.276C133.749 112.276 132.539 117.489 131.937 122.123",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M151.201 78.4508C151.201 78.4508 149.724 79.1922 148.102 81.7001C146.48 84.2081 145.003 88.4826 145.299 89.5136C145.594 90.5445 148.397 88.778 148.397 88.778C148.397 88.778 151.357 102.047 153.998 101.022C159.31 98.9545 152.232 79.4876 152.232 79.4876C152.232 79.4876 152.232 78.7578 151.201 78.4508Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M139.797 80.2637C136.796 79.5223 137.596 76.661 138.343 75.0509H138.372C139.154 75.1435 140.248 75.381 140.799 74.5412C141.349 73.7013 141.841 69.3689 141.841 69.3689L146.417 65.8416C146.417 65.8416 145.554 71.3729 145.311 73.487C145.067 75.6011 145.131 76.0587 146.909 76.2614C146.909 76.2382 144.071 81.3468 139.797 80.2637Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M142.368 54.9873C142.086 56.5596 142.253 58.1794 142.848 59.6615C143.839 61.8045 148.061 64.2951 148.061 64.2951C148.061 64.2951 149.723 62.5575 149.967 64.4051C150.21 66.2528 149.428 68.0599 148.194 68.0309C146.961 68.002 146.781 66.6292 146.781 66.6292C145.687 68.2204 144.08 69.3878 142.229 69.9365C138.95 71.0196 137.282 70.8285 136.894 68.3089C136.506 65.7894 136.958 62.905 138.105 59.7715C139.251 56.638 141.91 55.0452 142.368 54.9873Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M154.589 76.5452L154.74 74.1879C155.468 73.5413 156.157 72.8508 156.802 72.1201C157.688 71.0891 158.279 69.6122 159.014 70.203C159.75 70.7937 157.983 72.5661 157.983 72.5661L157.833 73.7245L160.786 72.8441C160.786 72.8441 163.59 70.0408 163.735 70.7764C163.879 71.512 162.258 74.0199 161.082 75.3521C159.906 76.6842 156.361 77.0897 156.361 77.0897C156.361 77.0897 156.211 88.888 156.211 92.4327C156.211 95.9774 155.771 99.9623 154.74 100.692C153.709 101.422 150.459 100.837 151.201 95.0855C151.942 89.334 154.589 76.5452 154.589 76.5452Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M148.398 88.7895L147.512 85.9862",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M67.75 53.8521C67.75 53.8521 70.4085 57.223 70.6807 57.9644C70.8728 58.5043 71.0314 59.0556 71.1557 59.6151L72.8933 60.9009C72.9479 60.9403 72.994 60.9904 73.0285 61.0482C73.063 61.106 73.0853 61.1703 73.094 61.2371C73.1027 61.3038 73.0975 61.3717 73.079 61.4364C73.0604 61.5011 73.0287 61.5613 72.986 61.6133L71.6712 63.2293C71.6712 63.2293 72.8933 67.2837 72.8296 67.8629C72.7659 68.4421 68.5203 69.8844 68.5203 69.8844L68.1265 72.9889L60.0756 72.8846L60.0466 67.1331L56.832 59.6035C56.832 59.6035 59.7107 54.1706 67.75 53.8521Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3604 65.1986L67.4435 65.0828C67.554 65.5648 67.7621 66.019 68.055 66.4175C68.3479 66.8159 68.7193 67.1502 69.1463 67.3996",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3604 65.1986L67.4435 65.0828C67.554 65.5648 67.7621 66.019 68.055 66.4175C68.3479 66.8159 68.7193 67.1502 69.1463 67.3996",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5411 54.0432C58.5411 54.0432 55.5003 54.188 55.5177 58.3988C55.535 62.6096 59.798 66.5076 60.0296 67.1274C60.2613 67.7471 62.5434 67.4575 64.1477 66.861C65.0451 66.5685 65.8182 65.9831 66.3429 65.1986C66.3429 65.1986 64.808 62.9629 65.1208 62.3026C65.4336 61.6424 67.0785 62.2737 67.0785 62.2737C67.4427 62.0669 67.7713 61.8029 68.0516 61.4918C68.3296 61.1037 69.8181 59.4298 68.7872 58.5494C67.7562 57.669 66.1518 57.1362 66.8642 56.0241C67.5766 54.912 70.1251 53.8289 69.3779 51.4368C68.6308 49.0447 66.9627 49.12 65.5726 49.9019C64.1825 50.6839 63.8002 48.1643 61.0954 49.595C58.3905 51.0256 57.6317 53.1165 58.5411 54.0432Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0969 62.291C62.0393 62.7371 62.0393 63.1887 62.0969 63.6348",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7889 55.526C66.7889 55.526 66.2097 56.5975 63.8928 58.6769C63.0808 59.4052 62.5041 60.359 62.2363 61.4165",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3332 57.6516C67.3332 57.6516 64.9758 60.8488 63.7363 61.7987",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0864 54.2054C93.4815 55.3571 96.0109 56.2054 98.6161 56.7307C98.6161 56.7307 94.9034 54.217 91.3123 53.5914C90.9822 53.5451 90.8026 54.0606 91.0864 54.2054Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3968 73.2379L94.8219 61.9088C94.8219 61.9088 93.0843 59.0533 93.0843 58.1903C93.0843 57.3273 95.8529 54.2228 95.8529 54.2228C95.8529 54.2228 96.0788 52.5373 97.2835 53.3424C97.6314 53.5817 97.9113 53.907 98.096 54.2866C98.2807 54.6662 98.364 55.0872 98.3377 55.5086C98.8937 56.292 99.3986 57.1103 99.8494 57.9586C100.127 58.6305 97.4978 62.3663 97.4978 62.3663C97.4978 62.3663 97.0576 72.6587 95.8992 76.1977C94.7408 79.7366 94.4512 80.4722 93.6809 81.5089C92.9106 82.5457 89.25 80.7212 89.25 80.7212L90.3968 73.2379Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1654 182.545L77.3649 185.163C77.5336 185.22 77.6884 185.313 77.8194 185.434C77.9504 185.555 78.0547 185.702 78.1255 185.865C78.1964 186.029 78.2324 186.205 78.231 186.384C78.2297 186.562 78.1912 186.738 78.1179 186.9C78.0187 187.099 77.8463 187.25 77.6371 187.323C76.722 187.653 67.2115 190.914 64.4371 189.739C64.154 189.596 63.9154 189.379 63.7469 189.11C63.5784 188.842 63.4867 188.532 63.4814 188.215C63.5733 186.078 63.8074 183.95 64.1823 181.844C64.1823 181.844 67.7154 183.518 70.1654 182.545Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1288 186.906C78.2048 186.755 78.2468 186.589 78.2518 186.42C78.2568 186.251 78.2247 186.083 78.1578 185.927C76.1653 186.895 71.9314 188.708 68.0739 188.777C66.5417 188.871 65.004 188.741 63.5098 188.389C63.5466 188.673 63.6509 188.945 63.8142 189.181C63.9774 189.416 64.1948 189.61 64.4481 189.744C67.2398 190.903 76.7329 187.659 77.6481 187.329C77.8572 187.256 78.0297 187.104 78.1288 186.906Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2063 180.356C50.2063 180.356 49.5576 186.327 49.9051 186.918C50.2526 187.509 51.2894 187.908 53.0733 187.792C53.6202 187.78 54.1494 187.597 54.586 187.267C55.0226 186.938 55.3445 186.479 55.506 185.956C55.6682 185.528 55.2511 181.624 55.2396 180.941C55.228 180.257 50.2063 180.356 50.2063 180.356Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5232 184.839C54.9729 185.898 54.2721 186.576 52.4534 186.611C51.5181 186.649 50.5933 186.402 49.8007 185.904C49.7739 186.246 49.8092 186.589 49.9049 186.918C50.2583 187.497 51.2892 187.908 53.0732 187.792C53.62 187.78 54.1492 187.597 54.5858 187.267C55.0224 186.937 55.3443 186.479 55.5058 185.956C55.5564 185.586 55.5622 185.21 55.5232 184.839Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0169 111.645C72.3263 112.481 70.5438 113.117 68.7056 113.539L52.737 109.849C52.737 109.849 51.6771 118.804 51.706 120.344C51.735 121.885 52.2852 149.611 52.2852 149.611L50.1074 180.772C50.3333 181.237 50.6897 181.626 51.133 181.891C51.5764 182.157 52.0875 182.287 52.6038 182.267C53.6636 182.262 54.7101 182.031 55.6735 181.589L62.5197 149.154L64.043 183.587C64.043 183.587 64.9871 184.497 67.1417 184.45C67.7725 184.43 68.3865 184.242 68.9215 183.908C69.4565 183.573 69.8936 183.103 70.1883 182.545C70.1883 182.545 71.2483 169.223 72.8295 159.69C74.4107 150.156 74.6018 123.912 74.6018 123.912L74.0169 111.645Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8301 116.342C60.9245 116.796 63.0585 117.043 65.2013 117.078",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9111 114.622C52.9111 114.622 53.6525 115.607 55.616 115.607",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1113 174.262C69.1113 174.262 70.5825 156.591 71.5671 143.831C72.1613 136.316 72.2425 128.769 71.8104 121.242C71.8104 121.242 74.2662 118.543 72.546 113.881",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1116 176.226L68.376 181.873",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5025 149.16L60.7533 126.026L56.6699 122.099",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9477 98.9487C54.0322 98.6854 54.0288 98.4016 53.9379 98.1404C53.847 97.8792 53.6735 97.6547 53.4438 97.5007C51.6714 96.3018 47.3738 93.8344 46.001 97.0837C45.5999 98.3516 45.3206 99.6549 45.167 100.976C44.7847 103.577 44.9237 121.184 44.9411 122.986C44.9414 123.083 44.9297 123.18 44.9064 123.275C44.7558 123.964 44.1244 126.976 44.5646 128.772C45.0569 130.816 46.001 132.392 47.6054 132.826C49.2098 133.261 50.0844 131.407 49.8354 130.272C49.5863 129.137 50.1829 128.256 49.9338 127.121C49.7311 126.206 48.8623 123.814 48.5322 122.928C48.4524 122.709 48.4324 122.473 48.4742 122.244C48.926 119.927 51.4571 106.936 51.6483 106.31C51.8394 105.685 53.3222 100.97 53.9477 98.9487Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M47.125 129.16C47.125 129.16 49.1696 130.591 49.4071 131.911",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7734 127.973C47.7734 127.973 49.3952 129.032 49.8296 129.867",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0684 126.774L48.6476 127.573C48.6476 127.573 48.9372 130.759 49.8407 130.284C50.7443 129.809 50.2114 125.945 50.2114 125.945C50.2114 125.945 49.7538 125.001 48.3406 122.748",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0684 126.774L48.6476 127.573C48.6476 127.573 48.9372 130.759 49.8407 130.284C50.7443 129.809 50.2114 125.945 50.2114 125.945C50.2114 125.945 49.7538 125.001 48.3406 122.748",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9642 123.443C48.2765 124.585 48.2484 125.793 47.8831 126.918C47.3616 127.898 46.7813 128.846 46.1455 129.756C46.9947 130.569 47.7899 131.435 48.526 132.351",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9838 78.0511L43.7305 97.3559C43.7305 97.3559 48.1266 100.918 53.5769 100.831L57.0927 82.5052C57.0927 82.5052 53.1657 73.6839 48.9838 78.0511Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6714 71.7205C57.6714 71.7205 49.9564 75.5548 49.2324 77.2924C48.6532 78.7404 50.4256 88.9922 50.4603 90.7936C50.4951 92.5949 52.0358 108.071 52.4528 111.066C52.8698 114.06 62.8784 115.334 66.6896 114.182C70.5007 113.029 74.0396 112.589 74.0165 111.627C73.9933 110.666 73.4836 102.522 73.6921 100.964C73.9006 99.4063 75.5166 87.718 75.5166 87.718L90.0603 84.7061C90.0603 84.7061 90.7322 84.3007 90.7496 81.6711C90.7519 79.1891 90.6243 76.7087 90.3673 74.24C88.4835 74.6919 86.5355 74.8134 84.6101 74.5991C81.1001 74.2863 76.9414 73.3422 76.2001 73.5507C75.4587 73.7592 70.408 72.7051 68.7457 72.4966C66.4347 72.1838 60.5674 70.2261 57.6714 71.7205Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1962 99.8987L49.1748 82.9454",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7249 90.3244L48.7402 88.1177",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5171 87.6891L69.8467 88.6042",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M74.266 88.1177L70.0957 92.0447",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0257 75.1088C87.0257 75.1088 83.0987 80.9992 73.5303 83.2176",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultas);
export default __webpack_public_path__ + "static/media/consultas.f96aa5a48942d89e369109b0edf940ab.svg";
export { ForwardRef as ReactComponent };